import { render } from "./PartnersItem.vue?vue&type=template&id=2ffa43f6&scoped=true"
import script from "./PartnersItem.vue?vue&type=script&lang=js"
export * from "./PartnersItem.vue?vue&type=script&lang=js"

import "./PartnersItem.vue?vue&type=style&index=0&id=2ffa43f6&lang=scss&scoped=true"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ffa43f6"]])

export default __exports__